import React from 'react';

import classNames from 'classnames/bind';
import style from './SocialSharing.scss';
const ctx = classNames.bind(style);

import { Link } from 'react-router-dom';

import {
  FacebookShareButton,
  TwitterShareButton,
  VKShareButton,
} from 'react-share';

class SocialSharing extends React.Component {
  render() {
    const shareUrl = location.href;
    const shareImage =
      location.origin + location.pathname + 'images/sharing4.jpg';

    return (
      <div>
        <div className={ctx('network')} key={'facebook'}>
          <FacebookShareButton url={shareUrl} hashtag={'#альфаprivate'}>
            <span className={ctx('icon')}>
              <img src={'images/social/facebook.svg'} />
            </span>
            <span className={ctx('link')}>facebook</span>
          </FacebookShareButton>
        </div>
        <div className={ctx('network')} key={'vk'}>
          <VKShareButton
            url={shareUrl}
            title={'Специальный проект Альфа Private'}
            description={'Сервис частного банковского обслуживания'}
            image={shareImage}
          >
            <span className={ctx('icon')}>
              <img src={'images/social/vk.svg'} />
            </span>
            <span className={ctx('link')}>vkontakte</span>
          </VKShareButton>
        </div>
        <div className={ctx('network')} key={'twitter'}>
          <TwitterShareButton
            url={shareUrl}
            title={'Специальный проект Альфа Private'}
            hashtags={['альфаprivate']}
          >
            <span className={ctx('icon')}>
              <img src={'images/social/twitter.svg'} />
            </span>
            <span className={ctx('link')}>twitter</span>
          </TwitterShareButton>
        </div>
      </div>
    );
  }
}

export default SocialSharing;
